module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19xumWq/tc-custom/9781459286580.jpg?1728155782035",
      "alt": "This image is the cover for the book Perfect Father, From Here to Maternity"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Perfect Father, From Here to Maternity\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Sylvie's Wish")]), _c('br'), _c('br'), _vm._v("Life would be perfect for Sylvie Venner if she had a baby. Not marriage, not a husbandjust a baby. Of course, she would need a "), _c('i', [_vm._v("teensy")]), _vm._v(" favor from a willing male acquaintancesomeone who had no desire for a family. Fortunately, she had the perfect candidate."), _c('br'), _c('br'), _c('b', [_vm._v("Chase's Child")]), _c('br'), _c('br'), _vm._v("Confirmed bachelor Chase Buchanan would do almost anything for a friend. But what Sylvie wanted went above and beyond the call of duty! How could he agree to father her child, and still stay \"just friends\" when he wanted so much more?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elizabeth Bevarly\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Elizabeth Bevarly is the award-winning, nationally number one bestselling author of more than seventy novels and novellas. Her books have been translated into two dozen languages and published in three dozen countries. An honors graduate of the University of Louisville, she has called home places as diverse as San Juan, Puerto Rico and Haddonfield, New Jersey, but now resides back in her native Kentucky with her husband, her son, and two neurotic cats (as if there were any other kind).")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0